var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"value":_vm.currentPage,"circle":"","length":_vm.totalPages},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }